module.exports = {
  headline: 'Problems with your order?',
  text: `
  <p>Orders placed through the Spotin service are being fulfilled directly by the sellers, without Spotin involved, so it is the Seller who can help you with the order in the most efficient way.</p>
  <p>If you have a problem with your order and need to contact the seller, you can find the contact details of each seller or brand in the order confirmation email.</p>
  `, 
  index: [],
  list: [

    {
      heading: null,
      expandables: [  
        {
          header: 'I can\'t find contact details to the seller',
          content: `
            <p>You can find the seller's contact details within your order confirmation email from Spotin.</p>
            <p>If you cannot find your order confirmation email please check your junk email/spam folder to make sure it is not there.</p>
            <img class="expandableList-image" style="height: 436px;" src="https://storage.googleapis.com/spotin/img/website/Seller_contact_example.png" />
            `
        },
        {
          header: 'I can\'t find my order confirmation email',
          content: '<p>Please check your junk email/spam folder to make sure it is not there.</p>'
        },
        {
          header: 'I can\'t find the order id for a seller within my order',
          content: `
            <p>You can find the seller's order id within your order confirmation (send by Spotin).</p>
            <img class="expandableList-image" style="height: 436px;" src="https://storage.googleapis.com/spotin/img/website/Seller_order-id_example.png" />
            `
        },
        // {
        //   header: 'I can\'t find the Spotin reference number',
        //   content: `
        //     <p>In the unlikely event of a technical problem with your order Spotin will be notified and may want to reach out to you regarding your order. In such case your order:s Spotin reference number may be requested by our support.</p>
        //     <p>You can find the Spotin reference number in the bottom of your order confirmation email as seen in the figure below.</p>
        //     <img class="expandableList-image" style="height: 420px;" src="https://storage.googleapis.com/spotin/img/website/orderreference.png" />
        //     `
        // },
      ]
    },

  ]
};



// WEBPACK FOOTER //
// ./pages/content/orderSupport_EN.js